const SleepApi = 
[
    {
        id: 'one',
        name: "Introduction",
        image: "https://i.cbc.ca/1.6534070.1658953881!/fileImage/httpImage/sleep-app-reviews.jpg",
        content: `Sleep is a fundamental aspect of our overall well-being and plays a crucial role in maintaining good mental health. 
        Adequate and restful sleep is essential for cognitive function, emotional balance, and physical health.`
    },
    {
        id: 'two',
        name: "Sleep Basics",
        image: "https://www.cchwyo.org/images/blog/2022/iStock-851356944.jpg",
        content: `Getting the right amount of sleep is crucial for our overall well-being. The recommended amount of sleep varies depending on age.
        Our sleep is divided into cycles consisting of different stages`
    },
    {
        id: 'one',
        name: "Sleep Disorders",
        image: "https://www.drlalitmahajan.com/wp-content/uploads/2019/11/23668ed.jpg",
        content: `Sleep disorders can significantly impact sleep quality and overall mental well-being.
        it is important to consult with a healthcare professional or a sleep specialist.`
    },
]

// import axios from 'axios';

// const sleepApiData = ()=>{
//     axios.get('/sleepDetails')
//     .then((response)=>{
//       const data = response.data.data;
//       console.log('sleep data')
//       console.log(data);
//       return data;
//     })
//     .catch((e)=>{
//         console.log('there is error in fetchin data')
//         console.log('error is ',e);
//     })
// }

// const SleepApi = sleepApiData();



export default SleepApi;